import styled from 'styled-components';

export const Container = styled.div`
  margin: 10px 0;
  box-shadow: #fff 6px 6px 0px -1px, #000 6px 6px;
  border-radius: 22px;

  div.click {
    cursor: pointer;
    border-radius: 22px;
  }

  
  .carousel-news {
    border-radius: 22px;
    .carousel {
      border-radius: 22px;
    }
    .carousel.carousel-slider {
      border-radius: 22px;
      height: 312px;
      z-index: 1;
    }
    .carousel img {
      max-width: 470px;
      position: relative;
      z-index: 2;
      height: 312px;
      width: unset;
      object-fit: cover;

      @media (max-width: 524px) {
        width: 100%;
      }
    }
    img.background {
      max-width: 100%;
      position: absolute;
      z-index: 1;
      width: 100%;
      left: 0;
      filter: blur(20px);
    }
    .carousel.carousel-slider .legend {
      opacity: 1;
      z-index: 3;
      font-size: 16px;
    }
  }
`;
